import { OVERLAY_PADDING } from '../../../../core/components/data-point/constants.js';
import { DataPoint } from '../../../../core/types/data-point.js';
import { safeGet } from '../../../providers/HistogramDataProvider.js';
import type {
  HistogramBin,
  WeakMapBins,
  XScale,
  YScale,
} from '../../../types/histogram.js';

export const getDataPointDetails = (
  yScale: YScale,
  xScale: XScale,
  bin: HistogramBin,
  binsMap: WeakMapBins,
): DataPoint => {
  const { cumulativeValue, value, seriesId, color } = safeGet(binsMap, bin);
  const rangeValue = cumulativeValue ?? value ?? 0;
  const domainValue = yScale(rangeValue) ?? 0;
  const y = domainValue + OVERLAY_PADDING;
  const x = xScale(bin.from + (bin.to - bin.from) / 2) + OVERLAY_PADDING;

  return {
    id: seriesId,
    x: x,
    y: y,
    color,
  };
};
